<div class="row ms-2 ps-0 pe-0 ms-md-0 ms-md-0 ps-md-0 mt-3">
    <div class="col-12 ps-md-0">
        <h5>{{localize(langSection.RequestFormPage, langText.AdditionalInformation)}}</h5>
        <div class="row mb-3">
            <div class="col-11 col-lg-auto">
                <div class="request-input-long">
                    <label class="fw-bold display-block mb-0">{{localize(langSection.RequestFormPage, langText.RequestReason)}} {{isNewRequest ? '*' : ''}}</label>
                    <span class="request-reason-text {{errors.requestReason ? 'error' : ''}}">
                        <textarea class="form-control" [ngModel]="model.requestReason" [readonly]="isDisabled('requestReason')" maxlength="256"
                            (input)="onFieldChange('requestReason', $event.target.value)"></textarea>
                    </span>
                    @if (errors.requestReason) {
<span class="text-danger">{{errors.requestReason}}</span>
}
                </div>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-11 col-lg-auto">
                <div class="request-input-long">
                    <label class="fw-bold display-block mb-0">{{localize(langSection.RequestFormPage, langText.SpecialInstructions)}} *</label>
                    <span class="request-reason-text {{errors.specialInstructions ? 'error' : ''}}">
                        <textarea class="form-control {{errors.specialInstructions ? 'error' : ''}}" [ngModel]="model.specialInstructions"
                            [readonly]="isDisabled('specialInstructions')" maxlength="256"
                            (input)="onFieldChange('specialInstructions', $event.target.value)"></textarea>
                    </span>
                    @if (errors.specialInstructions) {
<span class="text-danger">{{errors.specialInstructions}}</span>
}
                </div>
            </div>
        </div>
    </div>
</div>